import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filterSection"]

  connect() {
    // Vérifier si des filtres sont déjà appliqués
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.toString() !== "") {
      // Si des filtres sont appliqués, afficher la section de filtres
      this.toggleFilters()
    }
  }

  toggleFilters() {
    this.filterSectionTarget.classList.toggle("hidden")
  }

  applyFilters(event) {
    // Cette méthode est appelée lors de la soumission du formulaire
    // Mais nous n'avons pas besoin d'ajouter de logique supplémentaire ici
    // car le formulaire est configuré pour soumettre les filtres via GET
  }
}
